export const usePaginationLogic = (page, totalPages) => {
  if (!isNaN(totalPages)) {
    const allPages = new Array(totalPages)
      .fill(1)
      .map((item, index) => index + 1);

    const getPages = () => {
      if (page < 5) {
        return [...allPages.slice(0, 5), "...", totalPages];
      }

      if (page >= totalPages - 3) {
        return [
          1,
          "...",
          ...allPages.slice(allPages?.length - 5, allPages?.length),
        ];
      }

      return [
        1,
        "...",
        page - 2,
        page - 1,
        page,
        page + 1,
        page + 2,
        "...",
        totalPages,
      ];
    };

    const paginationItems = totalPages <= 10 ? allPages : getPages();

    return paginationItems;
  }
  return null;
};
